<script>
export default {
	props: ['url', 'method', 'params'],
	data () {
		return {
			response: null,
			loading: true,
			error: false
		}
	},
	computed: {
		requestMethod: function () {
			return this.method ? this.method : 'get'
		},
		requestParams: function () {
			return this.params ? this.params : {}
		}
	},
	created () {
		this.$http({
			method: this.requestMethod,
			url: this.url,
			data: this.requestMethod === 'post' ? this.requestParams : {},
			params: this.requestMethod === 'get' ? this.requestParams : {}
		})
			.then(response => {
				this.response = response.data
			})
			.catch(err => {
				this.error = err
			})
			.finally(() => {
				this.loading = false
			})
	},
	render () {
		return this.$scopedSlots.default({
			data: this.response,
			loading: this.loading,
			error: this.error
		})
	}
}
</script>
